export enum ROUTES {
  LOGIN = "/login",
  ADMIN = "/admin",
  DASHBOARD = "dashboard",
  LOCATIONS = "locations",
  UNITS = "units",
  ALL = "all",
  UNITDESCRIPTION = "unitDescription",
  UNITSIZES = "unitSizes",
  UNITCATEGORY = "unitCategory",
  RESERVATIONS = "reservations",
  CHECKOUT = "checkout",
  CUSTOMERS = "customers",
  SYNC = "sync",
  INSURANCES = "insurances",
  GATES = "gates",
  CONTRACTS = "contracts",
  WEBSITE_SETTINGS = "websiteSettings",
  WEBSITE_UNIT_DESCRIPTIONS = "unit-descriptions",
  WEBSITE_GRAPHICS = "graphics",
}
